const LEAD_ID_KEY = 'lead_id';
const LATEST_PAGE_ID = 'page_id';
const WIZARD_ID = 'wizard_id';
const LOCATION_ID = 'location_id';


export const getLeadId = () => window.localStorage.getItem(LEAD_ID_KEY);
export const saveLeadId = (leadId) => window.localStorage.setItem(LEAD_ID_KEY, leadId);
export const destroyLeadId = () => window.localStorage.removeItem(LEAD_ID_KEY);

export const getPageId = () => window.localStorage.getItem(LATEST_PAGE_ID);
export const savePageId = (pageId) => window.localStorage.setItem(LATEST_PAGE_ID, pageId);
export const destroyPageId = () => window.localStorage.removeItem(LATEST_PAGE_ID);

export const getWizardId = () => window.localStorage.getItem(WIZARD_ID);
export const saveWizardId = (wizardId) => window.localStorage.setItem(WIZARD_ID,wizardId);
export const destroyWizardId = () => window.localStorage.removeItem(WIZARD_ID);

export const getLocationId = () => window.localStorage.getItem(LOCATION_ID);
export const saveLocationId = (locationId) => window.localStorage.setItem(LOCATION_ID,locationId);
export const destroyLocationId = () => window.localStorage.removeItem(LOCATION_ID);


export default { 
    getLeadId, 
    saveLeadId, 
    destroyLeadId, 
    getPageId, 
    savePageId, 
    destroyPageId,
    getWizardId,
    saveWizardId,
    destroyWizardId,
    getLocationId,
    saveLocationId,
    destroyLocationId
 };
